import React from 'react'
import AddEvent from './AddEvent'
import { browserHistory } from 'react-router'
import { SubmissionError } from 'redux-form'
import Spinner from '../Spinner/Spinner'
import { connect } from 'react-redux'
import { NotificationManager } from 'react-notifications'
import { flattenArray } from '../../../helpers/utility'

import {
  processEventInitialValues,
  processEventFormData,
  processEventTicketAndExtensions
} from './eventFormUtil'

import {
  FETCH_SINGLE_EVENT_REQUEST,
  ADD_EVENT_REQUEST,
  EDIT_EVENT_REQUEST
} from '../../../actions/actions'

class EventCreateUpdate extends React.Component {
  constructor(props) {
    super(props)

    this.editModeRegEx = /\/dashboard\/events\/edit\/\d{1,}/
    const isLoading = this.isInEditMode()

    this.state = {
      isLoading,
      eventData: {}
    }
  }

  getEventId = () => this.props.params.eventId

  isInEditMode = () => this.editModeRegEx.test(this.props.location.pathname)

  componentDidMount = () => {
    if (!this.isInEditMode()) return

    this.getInitialData()
  }

  getInitialData = () => {
    new Promise((resolve, reject) => {
      this.props.getEventData(this.getEventId(), resolve, reject)
    })
      .then(this.handleEventFetchSuccess)
      .catch(this.handleEventFail)
  }

  handleEventFetchSuccess = ({ event }) => {
    this.setState({ eventData: event, isLoading: false })
  }

  handleEventFail = error => {
    if (!error || !error.general_errors) return

    for (let errorMsg of flattenArray(error.general_errors)) {
      NotificationManager.error(errorMsg)
    }
  }

  getFormInitialValues = () =>
    this.isInEditMode() ? processEventInitialValues(this.state.eventData) : undefined

  handleSubmit = rawValues => {
    const processedValues = this.processFormValues(rawValues)


    NotificationManager.info('در حال ارسال اطلاعات...', null, 3000)

    if (this.isInEditMode()) {
      return this.submitEventEdit(processedValues)
    }

    return this.submitNewEvent(processedValues)
  }

  processFormValues = rawValues => {
    const inEditMode = this.isInEditMode()
    const formData = new FormData()

    if (!inEditMode) {
      // only the general values
      processEventFormData(rawValues, formData)
      return formData
    }

    // both general values + extensions and tickets
    processEventFormData(rawValues, formData)
    processEventTicketAndExtensions(rawValues, formData)
    return formData
  }

  submitNewEvent = eventData =>
    new Promise((resolve, reject) => this.props.createEvent(eventData, resolve, reject))
      .then(this.handleNewEventSubmitSuccess)
      .catch(this.handleEventSubmitFail)

  submitEventEdit = eventData =>
    new Promise((resolve, reject) =>
      this.props.editEvent(this.getEventId(), eventData, resolve, reject)
    )
      .then(this.handleEditEventSubmitSuccess)
      .catch(this.handleEventSubmitFail)

  // ────────────────────────────────────────────────────────────────────────────────

  handleNewEventSubmitSuccess = event => {
    NotificationManager.success('رویداد جدید با موفقیت اضافه شد', null, 6000)

    if (!this.props.editMode) {
      // browserHistory.push(`/dashboard/events/edit/${event.id}`)
      browserHistory.push(`/dashboard/events/`)
    }
  }

  // ────────────────────────────────────────────────────────────────────────────────

  handleEditEventSubmitSuccess(data) {
    NotificationManager.success('رویداد با موفقیت ویرایش شد', null, 6000)
  }

  // ────────────────────────────────────────────────────────────────────────────────

  handleEventSubmitFail(errors) {
    NotificationManager.error('لطفا اشکالات فرم را رفع کنید', null, 6000)
    console.log(errors)

    throw new SubmissionError({
      _error: flattenArray(errors.general_errors || []),
      ...(errors.form_errors || {})
    })
  }

  // ────────────────────────────────────────────────────────────────────────────────

  render() {
    if (this.state.isLoading) return <Spinner />

    return (
      <AddEvent
        {...this.props}
        eventId={this.getEventId()}
        editMode={this.isInEditMode()}
        initialValues={this.getFormInitialValues()}
        onSubmit={this.handleSubmit}
      />
    )
  }
}

const actions = {
  getEventData: (eventId, resolve, reject) => ({
    type: FETCH_SINGLE_EVENT_REQUEST,
    eventId,
    resolve,
    reject
  }),
  createEvent: (formData, resolve, reject) => ({
    type: ADD_EVENT_REQUEST,
    formData,
    resolve,
    reject
  }),
  editEvent: (eventId, formData, resolve, reject) => ({
    type: EDIT_EVENT_REQUEST,
    eventId,
    formData,
    resolve,
    reject
  })
}

export default connect(
  null,
  actions
)(EventCreateUpdate)



// WEBPACK FOOTER //
// ./src/components/common/events/EventCreateUpdate.js